import { useThemeContext } from '../../../features/Theme/providers/ThemeContextProvider';
import SuccessIcon from '../../assets/icons/success.svg?react';
import WarningIcon from '../../assets/icons/warning.svg?react';
import { Row } from '../Row/Row';
import { MessageContainer, MessageContent, MessageType } from './style';

export interface MessageProps {
	message: string;
	type: MessageType;
}

export function Message({ message, type }: MessageProps) {
	const theme = useThemeContext();

	return (
		<MessageContainer type={type}>
			<Row $gap={12} $spaceBetween={true}>
				<MessageContent>{message}</MessageContent>
				{type === 'success' && <SuccessIcon data-testid="success-icon" fill={theme.colors.success[200]} width={58} />}
				{type === 'warning' && <WarningIcon data-testid="warning-icon" fill={theme.colors.warning[200]} width={58} />}
				{type === 'error' && <WarningIcon data-testid="error-icon" fill={theme.colors.error[200]} width={58} />}
			</Row>
		</MessageContainer>
	);
}
